import Api from "./api"

const fetchContacts = () => {
    return Api().get('/contacts')
        .then((response) => {
            return response
        })
}

export {fetchContacts}